module.exports = __webpack_public_path__ + "static/media/4.2.8-similar.1fa817ac.png";